import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import DashboardLayout from '../components/layout/DashboardLayout';
import paymentService from '../services/paymentService';

const PaymentCallback: React.FC = () => {
  const [status, setStatus] = useState<'loading' | 'success' | 'failed'>('loading');
  const [refId, setRefId] = useState<string>('');
  const [redirectUrl, setRedirectUrl] = useState<string>('');
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const processPaymentResult = async () => {
      try {
        // Get query parameters from URL
        const searchParams = new URLSearchParams(location.search);
        
        // Backend already verified payment and sends simplified parameters
        const paymentStatus = searchParams.get('status');
        const refIdParam = searchParams.get('refId');
        const message = searchParams.get('message');
        const returnUrl = searchParams.get('returnUrl');

        // Store the return URL for redirecting back
        if (returnUrl) {
          setRedirectUrl(returnUrl);
        }

        // Process the payment result
        if (paymentStatus === 'success') {
          setStatus('success');
          setRefId(refIdParam || '');
          toast.success('پرداخت با موفقیت انجام شد', {
            position: 'top-center',
            rtl: true,
          });
        } else {
          setStatus('failed');
          toast.error(message || 'پرداخت ناموفق بود', {
            position: 'top-center',
            rtl: true,
          });
        }
      } catch (error: any) {
        setStatus('failed');
        toast.error('خطا در پردازش نتیجه پرداخت', {
          position: 'top-center',
          rtl: true,
        });

      }
    };

    processPaymentResult();
  }, [location.search, navigate]);

  return (
    <DashboardLayout>
      <div className="container mx-auto py-8 px-4">
        <div className="max-w-md mx-auto bg-white rounded-xl shadow-md overflow-hidden md:max-w-2xl p-6">
          {status === 'loading' && (
            <div className="text-center py-10">
              <div className="animate-spin rounded-full h-16 w-16 border-t-2 border-b-2 border-indigo-500 mx-auto"></div>
              <p className="mt-4 text-gray-600">در حال بررسی وضعیت پرداخت...</p>
            </div>
          )}

          {status === 'success' && (
            <div className="text-center py-10">
              <div className="flex items-center justify-center w-16 h-16 mx-auto bg-green-100 rounded-full">
                <svg className="w-10 h-10 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
                </svg>
              </div>
              <h2 className="mt-4 text-2xl font-bold text-gray-800">پرداخت موفقیت آمیز</h2>
              <p className="mt-2 text-gray-600">
                پرداخت شما با موفقیت انجام شد .
              </p>
              {refId && (
                <p className="mt-2 text-gray-500">
                  شماره پیگیری: <span className="font-bold text-indigo-600">{refId}</span>
                </p>
              )}
              <div className="mt-6">
                <button
                  onClick={() => {
                    if (redirectUrl) {
                      window.location.href = redirectUrl;
                    } else {
                      navigate('/home');
                    }
                  }}
                  className="px-6 py-2 text-white bg-indigo-500 rounded-md hover:bg-indigo-600 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-opacity-50"
                >
                  {redirectUrl ? 'بازگشت به صفحه قبلی' : 'مشاهده'}
                </button>
              </div>
            </div>
          )}

          {status === 'failed' && (
            <div className="text-center py-10">
              <div className="flex items-center justify-center w-16 h-16 mx-auto bg-red-100 rounded-full">
                <svg className="w-10 h-10 text-red-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12"></path>
                </svg>
              </div>
              <h2 className="mt-4 text-2xl font-bold text-gray-800">پرداخت ناموفق</h2>
              <p className="mt-2 text-gray-600">
                متاسفانه پرداخت شما با مشکل مواجه شد. لطفا مجددا تلاش کنید.
              </p>
              <div className="mt-6 flex justify-center gap-4">
                <button
                  onClick={() => {
                    if (redirectUrl) {
                      window.location.href = redirectUrl;
                    } else {
                      navigate('/home');
                    }
                  }}
                  className="px-6 py-2 text-white bg-indigo-500 rounded-md hover:bg-indigo-600 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-opacity-50"
                >
                  {redirectUrl ? 'بازگشت به صفحه قبلی' : 'بازگشت'}
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    </DashboardLayout>
  );
};

export default PaymentCallback;
